import { useSnapshot } from 'valtio';

import { currentFeatureFlagState } from './client/manager';
import { FeatureFlagKey } from './featureFlags';

export const useBooleanFeatureFlag = (
  flagKey: FeatureFlagKey,
  defaultValue = false
): boolean => {
  const featureFlagState = useSnapshot(currentFeatureFlagState);
  if (featureFlagState[flagKey]) {
    return featureFlagState[flagKey].enabled;
  }

  return defaultValue;
};
